import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';
import { UserMeasurementSystem } from '../../../_models/measurement-system.model';

@Pipe({
  name: 'weightFormatter',
  standalone: false,
})
export class WeightFormatter implements PipeTransform {
  // @param value: string
  // @param args: any

  transform(value: string | number, units?: UserMeasurementSystem): string {
    const weight = Number(value);
    value = formatNumber(weight, 'en', '1.2-2');
    return `${String(value)} ${units ? units.WEIGHT.display : ''}`;
  }
}
